import React, { useEffect, useState } from "react";

const RELS = ["parent", "guardian", "other"];

const MinorConsentQuestion = ({ onSubmit, onNext, initialValue }) => {
    const [name, setName] = useState("");
    const [relationship, setRelationship] = useState("");
    const [nameErr, setNameErr] = useState("");
    const inputRef = React.useRef(null);

    useEffect(() => {
        if (initialValue && typeof initialValue === "object") {
            setName(initialValue.name || "");
            setRelationship(initialValue.relationship || "");
        }
    }, [initialValue]);

    // Delayed autofocus to allow smooth transition
    useEffect(() => {
        const timer = setTimeout(() => {
            inputRef.current?.focus();
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    const validateName = (v) => {
        if (!v) return "This field is required.";
        if (!/.+ .+/.test(v)) return "Please enter both first and last name.";
        return "";
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const err = validateName(name);
        setNameErr(err);
        if (err || !relationship) return;

        onSubmit({ name: name.trim(), relationship });
        onNext();
        setName(""); setRelationship(""); setNameErr("");
    };

    return (
        <form onSubmit={handleSubmit} className="input-form">
            <div className="input-field-container" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <input
                    type="text"
                    className={`input-field ${nameErr ? "input-error" : ""}`}
                    placeholder="Full name of parent or guardian"
                    value={name}
                    onChange={(e) => { setName(e.target.value); if (nameErr) setNameErr(""); }}
                    ref={inputRef}
                />
                {nameErr && <div className="error-message">{nameErr}</div>}
                <div className="treatment-options" style={{ justifyContent: "flex-start", flexWrap: "wrap", gap: 8 }}>
                    {RELS.map(r => (
                        <button
                            type="button"
                            key={r}
                            className={`treatment-button ${relationship === r ? "treatment-button-selected" : ""}`}
                            onClick={(e) => { e.currentTarget.blur(); setRelationship(r); }}
                        >
                            {r.charAt(0).toUpperCase() + r.slice(1)}
                        </button>
                    ))}
                </div>

                <button
                    type="submit"
                    className="multiselect-submit-button"
                    disabled={!name || !relationship || Boolean(nameErr)}
                    style={{ alignSelf: "center" }}
                >
                    Continue
                </button>
            </div>
        </form>
    );
};

export default MinorConsentQuestion;
